import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_GET_VEHICLE_DATA_REQUEST = `${VEHICLE_MODULE_PREFIX}_GET_VEHICLE_DATA_REQUEST`;
export const VEHICLE_GET_VEHICLE_DATA_SUCCESS = `${VEHICLE_MODULE_PREFIX}_GET_VEHICLE_DATA_SUCCESS`;
export const VEHICLE_GET_VEHICLE_DATA_FAILURE = `${VEHICLE_MODULE_PREFIX}_GET_VEHICLE_DATA_FAILURE`;
export const VEHICLE_RECIEVED_VEHICLE_RESPONSE_DATA = `${VEHICLE_MODULE_PREFIX}_RECIEVED_VEHILCE_DATA`;
/**
 * Action creator to retrieve vehicle data for the given job id
 * @param payload jobId guid
 * @returns
 */
export const onGetVehicleDataRequest = (payload) => ({
    type: VEHICLE_GET_VEHICLE_DATA_REQUEST,
    payload
});
/**
 * Action creator to fill vehicle state with vehicle data passed in payload.
 * This action allows other domain to pass vehicle data payload to fill vehicle state
 * @param payload IVehicle state data
 * @returns
 */
export const onGetVehicleDataSuccess = (payload) => ({
    type: VEHICLE_GET_VEHICLE_DATA_SUCCESS,
    payload
});
/**
 * Action creator to handle error occurred while retrieving vehicle from server and can be
 * usefull for other vehicle domain to take appropriate action
 * @param errorMessage string
 * @returns
 */
export const onGetVehicleDataFailure = (errorMessage) => ({
    type: VEHICLE_GET_VEHICLE_DATA_FAILURE,
    payload: errorMessage
});
/**
 * Action creator to notify all listner with vehicle response data to normalize their peice of data
 * to fill respective state
 * @param vehicleResponse: SAGASERVICEONLY_IVehicle
 * @returns
 */
export const onRecievedVehicleData = (vehicleResponse) => ({
    type: VEHICLE_RECIEVED_VEHICLE_RESPONSE_DATA,
    payload: vehicleResponse
});
//# sourceMappingURL=getVehicleDataActions.js.map